import { render, staticRenderFns } from "./CreateAccountVerifyEmailAddress.vue?vue&type=template&id=f13052fa&scoped=true&"
import script from "./CreateAccountVerifyEmailAddress.vue?vue&type=script&lang=js&"
export * from "./CreateAccountVerifyEmailAddress.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountVerifyEmailAddress.vue?vue&type=style&index=0&id=f13052fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13052fa",
  null
  
)

export default component.exports